import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { BaseViewComponent } from '../../../../../../../shared/core/interfaces/baseViewComponent';
import { LookupService } from '../../../../../../../shared/core/services/lookup.service';

@Component({
  selector: 'pars-filter-location',
  templateUrl: './filter-location.component.html',
  styleUrls: ['./filter-location.component.css']
})
export class FilterLocationComponent extends BaseViewComponent {
  @Input() set searchValues(value: any) {
    if (value) {
      this.searchLocation = value;
      this.reset();
    }
  }

  @Output() search = new EventEmitter<any>();
  @Output() clear = new EventEmitter<boolean>(false);

  searchLocation: any = {};
  searchFormGroup: FormGroup;
  isSearching = false;

  constructor(
    private _formBuilder: FormBuilder,
    lookupService: LookupService) {
    super(lookupService);

    this.searchFormGroup = this._formBuilder.group({
      locationName: "",
      city: "",
      stateNameId: ""
    });
  }

  onClearClick() {
    this.searchFormGroup.patchValue({
      locationName: "",
      city: "",
      stateNameId: ""
    });
    this.clear.emit(true);
  }

  onKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onSearchClick();
    }
  }

  onSearchClick() {
    this.isSearching = true;
    this.searchLocation = {
      "Name": this.searchFormGroup.get("locationName").value,
      "City": this.searchFormGroup.get("city").value,
      "StateNameId": this.searchFormGroup.get("stateNameId").value
    };
    console.log("search location: ", this.searchLocation);
    this.search.emit(this.searchLocation);
  }

  onSearchComplete() {
    this.isSearching = false;
  }

  reset() {
    this.searchFormGroup.get("locationName").setValue(this.searchLocation["Name"]);
    this.searchFormGroup.get("city").setValue(this.searchLocation["City"]);
    this.searchFormGroup.get("stateNameId").setValue(this.searchLocation["StateNameId"]);
  }

}